import { useState, Fragment, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap'
import Utils from '../Utils'

const ModalEditarLote = ({ isOpen, lote, closeModal, fetchLotes }) => {

    const [form, setForm] = useState(lote)

    const onSubmit = event => {
        event.preventDefault()
    }

    const handleInputChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const guardarCambios = async () => {
        if(window.confirm("Realmente quieres modificar el lote?") == false) {
            return;
        }
        //
        try {
            let _partida = form.PartidaRegistral
            if(typeof _partida == "string" && _partida.trim() == "") {
                _partida = null
            }
            // call API
            await Utils.API.ModificarLote(lote.idLote, form.Precio, form.Area, _partida)
            //refresh
            fetchLotes()
            closeModal()
            alert("Lote modificado!")
        } catch(err) {
            console.error(err)
            Utils.AlertError(err, "No se pudo actualizar el Lote")
        }
    }

    useEffect(() => {
        setForm(lote)
    }, [lote])


    return(
        <Modal
            isOpen={isOpen}
            backdrop={"static"}
        >
            <ModalHeader>Modificar Lote: {lote.ManzanaLote}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label>Área:</Label>
                        <Input
                            onChange={handleInputChange}
                            type="number"
                            name="Area"
                            value={form.Area}
                            min={1}
                            step="0.01"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Precio:</Label>
                        <Input
                            onChange={handleInputChange}
                            type="number"
                            name="Precio"
                            value={form.Precio}
                            min={1}
                            step="0.01"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Partida Registral:</Label>
                        <Input
                            onChange={handleInputChange}
                            type="text"
                            name="PartidaRegistral"
                            value={form.PartidaRegistral ? form.PartidaRegistral : ""}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button onClick={guardarCambios} color='primary'>
                    Modificar
                </Button>
                <Button onClick={closeModal} color='danger'>
                    Cancelar
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ModalEditarLote